class Home2LabTheme {
  constructor(scope = document) {
    this.scope = scope;
    this.bindMobileCart();
    this.bindLetterIntake();
    this.normalizeProductDetails();
  }

  bindMobileCart() {
    const sticky = this.scope.querySelector('[data-h2l-mobile-cart]');
    const section = sticky?.closest('.shopify-section') || this.scope;
    const buyBox = section.querySelector('.product__info-container');
    if (!buyBox || !sticky || sticky.dataset.h2lReady) return;
    sticky.dataset.h2lReady = 'true';
    const button = sticky.querySelector('button');
    const price = sticky.querySelector('[data-h2l-sticky-price]');
    const sync = () => {
      const submit = buyBox.querySelector('.product-form__submit');
      const priceBox = buyBox.querySelector('[id^="price-"]');
      const displayedPrice = priceBox?.querySelector('.price--on-sale .price-item--sale')
        || priceBox?.querySelector('.price-item--regular');
      if (price) price.textContent = priceBox?.classList.contains('hidden') ? '' : displayedPrice?.textContent.trim() || '';
      button.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      button.textContent = submit?.querySelector('span')?.textContent.trim() || submit?.textContent.trim() || 'Unavailable';
    };
    sync();
    const updates = new MutationObserver(sync);
    updates.observe(buyBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      observer.observe(buyBox);
    }
    section.addEventListener('shopify:section:unload', () => { updates.disconnect(); observer?.disconnect(); }, { once: true });
    button.addEventListener('click', () => {
      if (!button.disabled) buyBox.querySelector('.product-form__submit')?.click();
    });
  }

  bindLetterIntake() {
    const config = this.scope.querySelector('[data-h2l-letter-intake]');
    if (!config) return;

    let destinations = {};
    try { destinations = JSON.parse(config.textContent); } catch (_) { return; }

    const section = config.closest('.shopify-section') || this.scope;
    const form = section.querySelector('product-form form');
    const submit = form?.querySelector('[name="add"]');
    if (!form || !submit || form.dataset.h2lIntakeReady) return;
    form.dataset.h2lIntakeReady = 'true';
    form.closest('product-form').dataset.h2lLetter = 'true';
    submit.removeAttribute('aria-haspopup');

    if (!submit.disabled && submit.querySelector('span')) submit.querySelector('span').textContent = 'Start your request';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
      const variantId = form.querySelector('[name="id"]')?.value;
      const selection = destinations[variantId] || destinations.default;
      const destination = typeof selection === 'string' ? selection : selection?.url;
      if (!destination) return;
      const intakeUrl = new URL(destination, window.location.origin);
      intakeUrl.searchParams.set('shopify_variant_id', variantId || '');
      if (typeof selection === 'object' && selection.title) {
        intakeUrl.searchParams.set('shopify_variant_title', selection.title);
      }
      window.location.assign(intakeUrl.toString());
    }, { capture: true });
  }

  normalizeProductDetails() {
    const details = this.scope.querySelector('.h2l-product-details');
    if (!details) return;

    details.querySelectorAll('img:not([alt])').forEach((image) => {
      image.alt = `${details.dataset.productTitle || 'Home2Lab product'} supporting information`;
    });
  }
}

const bootHome2LabTheme = (event) => new Home2LabTheme(event?.type === 'shopify:section:load' ? event.target : document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootHome2LabTheme, { once: true });
} else {
  bootHome2LabTheme();
}

document.addEventListener('shopify:section:load', bootHome2LabTheme);
